import { getGroupPermissionFactory } from '../../../common';
import { OrderManagementEndUserPermissions } from './order-management.end-users.permissions';

export class OnStreetReservationsPermissions {
  static GroupName = `${OrderManagementEndUserPermissions.GroupName}.OnStreetReservations`;
  static getPermissions = getGroupPermissionFactory(OnStreetReservationsPermissions.GroupName);

  static Permissions = {
    ReadAll: OnStreetReservationsPermissions.getPermissions('ReadAll'),
  };
}
